import { EventEmitter, h, Component, Prop, Element, Host, Event, Method } from '@stencil/core';

@Component({
  tag: 'pk-side-panel',
  styleUrl: './scss/pk-side-panel.scss',
  shadow: true,
})
export class PkSidePanel {
  // Reference to host HTML element
  // ===================================
  @Element() el!: HTMLPkSidePanelElement;

  // Public Property API
  // ========================

  /** Id identifier */
  @Prop() uid: string;

  /** Left/right side panel  */
  @Prop() position: 'left' | 'right' = 'right';

  /** Side panel mobile width (default 100vw) */
  @Prop() mobileWidth: string = '100vw';

  /** Side panel desktop width (default 25vw) */
  @Prop() desktopWidth: string = '25vw';

  /** Side panel content left padding (default = 24px) */
  @Prop() paddingLeft: number = 24;

  /** Side panel content right padding (default = 24px) */
  @Prop() paddingRight: number = 24;

  /** Side panel content top padding (default = 40px) */
  @Prop() paddingTop: number = 40;

  /** Side panel content bottom padding (default = 40px) */
  @Prop() paddingBottom: number = 40;

  /** Overlay open/close */
  @Prop() isOpen: boolean = false;

  // Prop lifecycle events
  // =======================

  // Methods
  // ==============

  /** Method to open/close the side panel */
  @Method()
  async toggle() {
    this.isOpen = !this.isOpen;
    this.pkSidePanelToggled.emit();
  }

  // Events section
  // ==============================================
  /** Event emitted on toggled */
  @Event() pkSidePanelToggled: EventEmitter<UIEvent>;

  // Component lifecycle events
  // Ordered by their natural call order
  // =====================================

  // render() function
  // Always the last one in the class.
  // ===================================
  render() {
    const style = {
      ...(this.mobileWidth && { '--side-panel--mobile-width': this.mobileWidth }),
      ...(this.desktopWidth && { '--side-panel--desktop-width': this.desktopWidth }),
      ...(this.paddingBottom && { '--side-panel--padding-bottom': `${this.paddingBottom}px` }),
      ...(this.paddingLeft && { '--side-panel--padding-left': `${this.paddingLeft}px` }),
      ...(this.paddingRight && { '--side-panel--padding-right': `${this.paddingRight}px` }),
      ...(this.paddingTop && { '--side-panel--padding-top': `${this.paddingTop}px` }),
    };

    return (
      <Host
        id={this.uid}
        class={{ 'is-open': this.isOpen, 'side-panel__left': this.position === 'left', 'side-panel': true }}
        style={{ ...style }}
      >
        <slot name="content" />
      </Host>
    );
  }
}
